
<script>
	import { draw } from 'svelte/transition';

	export let name = undefined;
	export let size = '1em';
	export let className = '';
	export let strokeColor = 'white';
	export let strokeWidth = '0.05em';
	export let fillColor = 'none';
	export let cycleStrokeColor = false;
	export let animateDraw = true;

	let paths = [];
	let viewBox = '0, 0, 0, 0';
	let baseClass = '';

	switch (name) {
		case 'close':
			viewBox = '0 0 32 32';
			paths.push('M2 30 L30 2 M30 30 L2 2');
			baseClass = 'close';
			break;

		case 'next':
			viewBox = '0 0 32 32';
			paths.push('M12 30 L24 16 12 2');
			baseClass = 'next';
			break;

		case 'previous':
			viewBox = '0 0 32 32';
			paths.push('M20 30 L8 16 20 2');
			baseClass = 'previous';
			break;

		case 'lightning':
			viewBox = '0 0 32 32';
			paths.push('M18 13 L26 2 8 13 14 19 6 30 24 19 Z');
			baseClass = 'lightning';
			break;

		case 'checkmark':
			viewBox = '0 0 32 32';
			paths.push('M2 20 L12 28 30 4');
			baseClass = 'checkmark';
			break;

		case 'x':
			viewBox = '0 0 32 32';
			paths.push('M2 30 L30 2 M30 30 L2 2');
			baseClass = 'x';
			break;

		case 'mute':
			viewBox = '0 0 32 32';
			paths.push('M20 16 C20 8 15 2 15 2 L8 10 2 10 2 22 8 22 15 30 C15 30 20 24 20 16 Z');
			baseClass = 'mute';
			break;

		case 'volume':
			viewBox = '0 0 32 32';
			paths.push('M20 16 C20 8 15 2 15 2 L8 10 2 10 2 22 8 22 15 30 C15 30 20 24 20 16 Z M21 2 C21 2 25 6 25 16 25 26 21 30 21 30 M27 4 C27 4 30 8 30 16 30 24 27 28 27 28');
			baseClass = 'volume';
			break;

		case 'cursor':
			viewBox = '0 0 32 32';
			paths.push('M28.6,20,6.9,0l0,29.48,6.59-6.3L17.34,32l6-2.65L19.5,20.53Z');
			baseClass = 'cursor';
			break;

		case 'play':
			viewBox = '0 0 32 32';
			paths.push('M10 2v28l14-14z');
			baseClass = 'play';
			break;

		case 'eye':
			viewBox = '0 0 32 32';
			paths.push('M17 14a1 1 0 010 2 1 1 0 010-2z');
			paths.push('M16 10c7.93.24 7.93 11.76 0 12-7.93-.24-7.93-11.76 0-12z');
			paths.push('M2 16C9.25 2.7 22.8 2.78 30 16 22.75 29.3 9.2 29.22 2 16z');
			baseClass = 'eye';
			break;

	}
</script>


<svg
	xmlns="http://www.w3.org/2000/svg"
	class={`icon ${baseClass} ${className}`}
	class:cycleStrokeColor={cycleStrokeColor}
	style="--fill-color:{fillColor}; --stroke-color:{strokeColor}; --stroke-width:{strokeWidth}"
	viewBox={viewBox}
	width={size}
	height={size}>
		<g>
			{#each paths as path}
				{#if animateDraw}
					<path d={path} transition:draw={{delay: 100, duration: 800}} />
				{:else}
					<path d={path} />
				{/if}
			{/each}
		</g>
</svg>

<style lang="less">
	.icon{
		position: relative;
		display: inline-block;
		filter: drop-shadow(0 0 2px white);
		stroke: var(--stroke-color);
		stroke-width: var(--stroke-width);
		fill: var(--fill-color);

		&.cycleStrokeColor {
			animation: cycle-stroke-color 1s infinite;
			@keyframes cycle-stroke-color {
				0% {
					stroke: var(--stroke-color);
				}
				50% {
					stroke: white;
				}
				100% {
					stroke: var(--stroke-color);
				}
			}
		}
	}
</style>
